import { IDeleteObraMateriaisControladosUseCase } from "../../../presentation/useCases/delete/delete_obra_materiais_controlados_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraMateriaisControladosUseCase
 */

export class DeleteObraMateriaisControladosUseCase implements IDeleteObraMateriaisControladosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteObraMateriaisControlados(id?: number): Promise<void> {
    await this.repository.deleteObraMateriaisControlados({ id });
  }
}
